import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header'; // Tu componente Header existente
import Footer from './Footer'; // Tu componente Footer existente
import { Box } from '@chakra-ui/react';

const Layout = () => {
  return (
    // Usamos un Box con display="flex" y flexDirection="column" 
    // para asegurar que el footer se pegue abajo si el contenido es corto.
    <Box display="flex" flexDirection="column" minH="100vh" bg="var(--bg-dark)">
      <Header />
      
      {/* "Outlet" es donde React Router renderizará la página actual (ej. IndexPage, CodeShowcasePage, etc.) */}
      {/* Usamos flex="1" para que el 'main' ocupe todo el espacio disponible */}
      <Box as="main" flex="1">
        <Outlet />
      </Box>
      
      <Footer />
    </Box>
  );
};

export default Layout;